module.exports = __webpack_public_path__ + "static/media/ITCAvantGardeStd-Bold.e16852b3.svg";